import { render } from "./index.vue?vue&type=template&id=6ed5c340&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=6ed5c340&scoped=true&lang=less"
import "@/style/manga-list.less?vue&type=style&index=1&id=6ed5c340&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed5c340"],['__file',"src/views/parent-path-list/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ed5c340"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ed5c340', __exports__)) {
    console.log('reload')
    api.reload('6ed5c340', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6ed5c340&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6ed5c340', render)
  })

}


export default __exports__